<template>
  <v-container
    id="where"
    class="pa-0 grey lighten-3 flex-wrap align-start fill-height"
    fluid
    tag="section"
  >
    <iframe
      allowfullscreen
      frameborder="0"
      height="500"
      src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d8520.641911992663!2d12.0181553!3d57.730717!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x95249d9f4d9267f1!2sBerg%20211!5e0!3m2!1sen!2sse!4v1655475890621!5m2!1sen!2sse"
      style="border:0"
      width="100%"
    />
    <v-row
      class="ma-0"
      justify="center"
    >
      <v-col
        cols="12"
        md="4"
      >
        <h1 class="display-1 mb-8 font-weight-bold">
          Info
        </h1>

        <div class="mb-8">
          The wedding starts at <strong>18:00</strong> at <strong>Berg 211, Artillerigatan 40, Göteborg.</strong>
          The tramstop <strong>SKF Läge B</strong> is just outside.
          This is not a family friendly event, do not bring children.
          <br>
          There will be a ceremony at 19:00. Please do not be late!
        </div>

        <div class="mb-4">
          <strong>Questions?</strong> <a href="mailto: wedding@isabellochdaniel.se">wedding@isabellochdaniel.se</a>
        </div>
        <div class="mb-4">
          <strong>Toastmaster</strong> <a href="mailto: toastmaster@isabellochdaniel.se">toastmaster@isabellochdaniel.se</a>
        </div>
        <div class="mb-4">
          <strong>Bachelorette party</strong> <a href="mailto: bachelorette-admin@isabellochdaniel.se">bachelorette-admin@isabellochdaniel.se</a>
        </div>
        <div class="mb-4">
          <strong>Bachelor party</strong> <a href="mailto: bachelor-admin@isabellochdaniel.se">bachelor-admin@isabellochdaniel.se</a>
        </div>
        <div class="mb-4">
          <strong>Boomer mail</strong>
          <p>
            Gånglåten 38<br>
            421 46 Västra Frölunda
          </p>
        </div>
      </v-col>

      <v-col
        cols="12"
        lg="6"
      >
        <v-img
          src="https://meetly.se/wp-content/uploads/berg211-gang.jpg"
        />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  export default {
    name: 'Where',
  }
</script>
